(function () {
    'use strict';

    angular
        .module('app')
        .controller('systemOptions', systemOptions);

    systemOptions.$inject = ['systemOptionsService', '$mdDialog', '$filter', 'loginService', '$rootScope'];

    function systemOptions(systemOptionsService, $mdDialog, $filter, loginService, $rootScope) {
        var vm = this;

        vm.systemOptionsLabel = loginService.resourceStrings["SYSTEM_OPTIONS"]; // "System Options"
        vm.systemOptionsDetailLabel = loginService.resourceStrings["SYSTEM_OPTIONS_DETAIL"]; // "System-wide administration options."
        vm.AvailableActionsLabel = loginService.resourceStrings["AVAILABLE_ACTIONS"]; // "Available Actions";
        vm.allowDownloadLabel = loginService.resourceStrings["ALLOW_DOWNLOAD"]; // "Make the download command available to users.";
        vm.VirtualLibraryLabel = loginService.resourceStrings["VIRTUAL_LIBRARY"]; // "Virtual Library";
        vm.clearVLatStartupLabel = loginService.resourceStrings["CLEAR_VL_AT_STARTUP"]; // "Clear Virtual Library for all users at web application startup";
        vm.clearVLNowButtonLabel = loginService.resourceStrings["CLEAR_VL_NOW_BUTTON"]; // "Clear";
        vm.clearVLNowLabel = loginService.resourceStrings["CLEAR_VL_NOW"]; // "Clear";

        vm.okLabel = loginService.resourceStrings["OK"]; // "OK"
        vm.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"

        vm.bAllowDownload = false;

        vm.changed = false;
        activate();
        vm.systemOptionsService = systemOptionsService;
        vm.loadingDataLabel = loginService.resourceStrings["LOADING_DATA"]; // "Loading Data"
        systemOptionsService.getClearVLAtStartup().then(function (data) {
            if (data != null) {
                vm.clearVLAtStartup = data;
            }
        });

        //when the "Clear" button is clicked
        vm.clearVirtualLibrary = function () {
            systemOptionsService.clearVirtualLibrary().then(function (data) {
                if (data != null) {
                    if (data == true) {
                        var title = loginService.resourceStrings["CLEAR_VL_NOW"];
                        var message = loginService.resourceStrings["CLEAR_VL_SUCCESS"];
                        $rootScope.msgBoxShow(message, title, 1);
                    }
                    else {
                        var title = loginService.resourceStrings["CLEAR_VL_NOW"];
                        var message = loginService.resourceStrings["CLEAR_VL_ERROR"];
                        $rootScope.msgBoxShow(message, title);
                    }
                }
            }, function () {
                var title = loginService.resourceStrings["CLEAR_VL_NOW"];
                var message = loginService.resourceStrings["CLEAR_VL_ERROR"];
                $rootScope.msgBoxShow(message, title);
            });
        }


        systemOptionsService.getAllowDownload().then(function (data) {
            if (data != null)
                vm.bAllowDownload = data;
        });


        //when the ok button is clicked
        vm.onOk = function () {
            //set the fields
            systemOptionsService.setAllowDownload(vm.bAllowDownload).then(function () {
                systemOptionsService.setClearVLAtStartup(vm.clearVLAtStartup).then(function () {
                    $mdDialog.hide();
                })
            })
        }

        //when the cancel button is clicked
        vm.onCancel = function () {
            $mdDialog.cancel();
        }

        function activate() { }
    }
})();
